import React, { useState } from "react";
import { useLedgerEntryContext } from "../context/ledgerEntry_context";

import { useLedgerAccountContext } from "../context/ledgerAccount_context";
import { useUserContext } from "../context/user_context";
import Alert from '../components/Alert';
import "../style/AddEntryModal.css";

const categoryOptions = [
  "Food",
  "Current Bill",
  "Water Bill",
  "Vegetable Expense",
  "Loan",
  "Donation",
  "Groups",
];

const AddEntryModal = ({ onClose,  groups = [], customersByGroup = {}, accounts = [] }) => {
  const { user } = useUserContext();
  const { addLedgerEntry,fetchLedgerEntries } = useLedgerEntryContext();
  const { fetchLedgerAccounts } = useLedgerAccountContext();
  

  const today = new Date().toISOString().split("T")[0];

  const defaultFormData = {
    ledgerAccountId: "",
    transactedDate: today,
    entryType: "CREDIT",
    category: "",
    subCategory: "",
    amount: "",
    description: "",
    subscriberId: "",
    subscriberName: "",
    membershipId: "",
  };

  const [formData, setFormData] = useState(defaultFormData);
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [selectedSubscriberId, setSelectedSubscriberId] = useState("");
  const [isConfirming, setIsConfirming] = useState(false);
  const [tempData, setTempData] = useState(null);

  const [list, setList] = useState([]);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setFormData((prev) => ({ ...prev, category }));

    if (category !== "Groups") {
      setSelectedGroupId("");
      setSelectedSubscriberId("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const selectedGroup = groups.find((g) => String(g.id) === String(selectedGroupId));

    const payload = {
      ...formData,
      membershipId: user?.results?.userAccounts?.[0]?.parent_membership_id || "",
      groupId: formData.category === "Groups" ? selectedGroupId : null,
      subscriberId: formData.category === "Groups" ? selectedSubscriberId : null,
      subCategory: formData.category === "Groups" ? selectedGroup?.name || "" : formData.subCategory,
      amount: parseFloat(formData.amount),  // <-- convert to float here
    };

    setTempData(payload);
    setIsConfirming(true);
  };

  const showAlert = (show = false, type = '', msg = '') => {
    console.log('hi');
    setAlert({ show, type, msg });
  };
  const handleConfirm = async () => {
    try {
      const response = await addLedgerEntry(tempData);
      const responseData = await response.json(); // Extract JSON
  
      if (response.ok) { // <-- check on response, not responseData
        fetchLedgerEntries();
        fetchLedgerAccounts();
        showAlert(true, 'success', responseData.message || 'Ledger entry added successfully!');
        
        setTimeout(() => {
          handleClose(); // Close after short delay
        }, 1000);
      } else {
        showAlert(true, 'danger', responseData.message || 'Failed to add ledger entry');
      }
    } catch (error) {
      showAlert(true, 'danger', 'An unexpected error occurred');
    }
  };
  



  const handleClose = () => {
    setFormData(defaultFormData);
    setSelectedGroupId("");
    setSelectedSubscriberId("");
    setIsConfirming(false);
    setTempData(null);
    setAlert({ show: false, type: "", message: "" });
    onClose?.();
  };

  const isConfirmDisabled = () => {
    if (!tempData) return true;
    const { amount, description, category, groupId, subscriberId } = tempData;
    if (!amount || !description) return true;
    if (category === "Groups" && (!groupId || !subscriberId)) return true;
    return false;
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>New Ledger Entry</h2>

        {alert.show && <Alert {...alert} removeAlert={showAlert} list={list} />}

        {isConfirming ? (
          <div className="confirmation-screen">
            <h3>Confirm Ledger Entry</h3>
            <p><strong>Date:</strong> {tempData.transactedDate}</p>
            <p><strong>Account:</strong> {
              tempData.ledgerAccountId
                ? accounts.find((acc) => String(acc.id) === String(tempData.ledgerAccountId))?.account_name || "N/A"
                : "N/A"
            }</p>
            <p><strong>Type:</strong> {tempData.entryType}</p>
            <p><strong>Category:</strong> {tempData.category}</p>

            {tempData.category === "Groups" && (
              <>
                <p><strong>Group:</strong> {groups.find(g => String(g.id) === String(tempData.groupId))?.name}</p>
                <p><strong>Subscriber:</strong> {
                  customersByGroup[tempData.groupId]?.find(c => String(c.id) === String(tempData.subscriberId))?.name || "N/A"
                }</p>
              </>
            )}

            <p><strong>Description:</strong> {tempData.description}</p>
            <div className="amount-highlight">₹ {tempData.amount}</div>

            <div className="modal-actions">
              <button onClick={() => setIsConfirming(false)}>Edit</button>
              <button onClick={handleConfirm} disabled={isConfirmDisabled()}>Confirm</button>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <label htmlFor="transactedDate">Transaction Date</label>
            <input
              id="transactedDate"
              type="date"
              name="transactedDate"
              value={formData.transactedDate}
              onChange={handleInputChange}
              required
            />

            <label htmlFor="ledgerAccountId">Select Account</label>
            <select
              id="ledgerAccountId"
              name="ledgerAccountId"
              value={formData.ledgerAccountId}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Account</option>
              {accounts.map((acc) => (
                <option key={acc.id} value={acc.id}>
                  {acc.account_name}
                </option>
              ))}
            </select>

            <label>Entry Type</label>
            <div className="radio-group">
              <label>
                <input
                  type="radio"
                  name="entryType"
                  value="CREDIT"
                  checked={formData.entryType === "CREDIT"}
                  onChange={handleInputChange}
                />
                Credit
              </label>
              <label>
                <input
                  type="radio"
                  name="entryType"
                  value="DEBIT"
                  checked={formData.entryType === "DEBIT"}
                  onChange={handleInputChange}
                />
                Debit
              </label>
            </div>

            <label htmlFor="category">Category</label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleCategoryChange}
              required
            >
              <option value="">Select Category</option>
              {categoryOptions.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>

            {formData.category === "Groups" && (
              <>
                <label htmlFor="groupId">Group Name</label>
                <select
                  id="groupId"
                  value={selectedGroupId}
                  onChange={(e) => {
                    setSelectedGroupId(e.target.value);
                    setSelectedSubscriberId("");
                  }}
                  required
                >
                  <option value="">Select Group</option>
                  {groups.map((group) => (
                    <option key={group.id} value={group.id}>
                      {group.name}
                    </option>
                  ))}
                </select>

                <label htmlFor="subscriberId">Subscriber Name</label>
                <select
                  id="subscriberId"
                  value={selectedSubscriberId}
                  onChange={(e) => setSelectedSubscriberId(e.target.value)}
                  required
                >
                  <option value="">Select Subscriber</option>
                  {(customersByGroup[selectedGroupId] || []).map((cust) => (
                    <option key={cust.id} value={cust.id}>
                      {cust.name}
                    </option>
                  ))}
                </select>
              </>
            )}

            <label htmlFor="amount">Amount</label>
            <input
              id="amount"
              type="number"
              name="amount"
              value={formData.amount}
              min="0"
              onChange={handleInputChange}
              required
            />

            <label htmlFor="description">Description</label>
            <input
              id="description"
              type="text"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              required
            />

            <div className="modal-actions">
              <button type="button" className="cancel" onClick={handleClose}>
                Cancel
              </button>
              <button type="submit">Save</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default AddEntryModal;
